import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { DeviceInfo } from "@/interface/deviceInfo";
import { RootState } from "@/redux/reducers";
import { ClusterState } from "@/components/PageCluster/redux/types";

const selectCluster = (state: RootState): ClusterState => state?.cluster;

export default createDraftSafeSelector(selectCluster, (cluster: ClusterState): DeviceInfo => cluster?.ua);
